import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { HomePage } from "./pages/HomePage"
import { InvitePage } from "./pages/InvitePage"
import { LoginPage } from "./pages/LoginPage"
import { WelcomePage } from "./pages/WelcomePage"
import { SignupPage } from "./pages/SignupPage"
import { StatusPage } from "./pages/StatusPage"
import { AdminPage } from "./pages/AdminPage"
import { PrivacyPage, TermsPage, AccessibilityPage } from "./pages/LegalPages"

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/i/:slug" element={<InvitePage />} />
        <Route path="/login/*" element={<LoginPage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/status" element={<StatusPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
